const formatString = (str: string) => {
  const words = str.split(' ')

  const formattedWords = words.map((word, index) => {
    const isMeaningless = ['de', 'no', 'na', 'do', 'da', 'dos', 'das', 'em', 'por'].includes(
      word.toLowerCase(),
    ) && index !== 0

    if (isMeaningless) {
      return word.toLowerCase()
    }

    return word.charAt(0).toUpperCase() + word.slice(1)
  })

  return formattedWords.join(' ')
}

export default formatString
